import { useEffect } from 'react';

import { DEFAULT_FILTERS_DATA } from '@app/pages/Analytics/data';
import type { UseReportEffectsProps } from '@app/pages/Analytics/types';

export const useReportEffects = ({
  handleSearchData,
}: UseReportEffectsProps) => {
  useEffect(() => {
    handleSearchData(DEFAULT_FILTERS_DATA);
  }, [handleSearchData]);
};
